module.exports = __webpack_public_path__ + "static/media/synth_success.fa2ab0f0.mp3";